import { Fn_activeAxios } from "../function/FnConfig";

export function load_menu_data(rootStore) {
    const searchStore = rootStore.searchStore;
    const api = Fn_activeAxios(rootStore);
    api.post('/gate/okgo/search_all_prod', JSON.stringify({ shopCd: searchStore.getShopCd }),
        {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
        })
        .then((res) => {
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    let data = res.data.data;
                    if (data) {
                        rootStore.menuStore.setMenuData(data);
                    }
                }
            }
        }).catch(err => {
        });
}

// 메뉴 품절처리
export async function one_prod_sold_out(rootStore, soldOut) {

    const searchStore = rootStore.searchStore;
    const menuStore = rootStore.menuStore;

    let data = JSON.stringify(
        {
            shopCd: searchStore.getShopCd
            , connPosNo: searchStore.getSession.connPosNo
            , items: [{ prodCd: menuStore.getMenuSoldOutCode, soldOut: (soldOut === true) ? 'Y' : 'N' }]
        }
    )

    const api = Fn_activeAxios(rootStore);
    let res = await api.post('/gate/okgo/update_sold_out', data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + rootStore.searchStore.getToken }
    })
        .then((res) => {
            // 레이어닫기
            if (res && res.status === 200) {
                if (res.data.resultCode === "000") {
                    return true
                }
            }
        }).catch(err => {
            rootStore.layerStore.setLayerAlertType("fail");
            rootStore.layerStore.setLayerAlertView(true);
        });
    return res;
}


